import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum ColliActionName {
    COLLI_CHANGE_STATE = 'colli_change_state',
    COLLI_PROCESS_PACKAGES = 'colli_process_packages',
    COLLI_CANCEL_PACKAGES = 'colli_cancel_packages',
    COLLI_ACKNOWLEDGE_PROCESSING = 'colli_acknowledge_processing',
    COLLI_ACKNOWLEDGE_PROCESSED = 'colli_acknowledge_processed',
    COLLI_ACKNOWLEDGE_PROCESSED_WITH_FAILURES = 'colli_acknowledge_processed_with_failures',
    COLLI_ACKNOWLEDGE_CANCELLED = 'colli_acknowledge_cancelled',
    COLLI_ACKNOWLEDGE_FAILED = 'colli_acknowledge_failed',
    COLLI_NOTIFY_SENDER = 'colli_notify_sender',
    COLLI_NOTIFY_RECEIVER = 'colli_notify_receiver',
    COLLI_NOTIFY_BACKUP_RECEIVER = 'colli_notify_backup_receiver',
    COLLI_CREATE_PIN_CODE = 'colli_create_pin_code',
    COLLI_SET_PIN_CODE = 'colli_set_pin_code',
    COLLI_RETIRE_PIN_CODE = 'colli_retire_pin_code',
    COLLI_RETURN_EQUIPMENT = 'colli_return_equipment',
    COLLI_TRANSFER_EQUIPMENT = 'colli_transfer_equipment',
    COLLI_WITHDRAW_EQUIPMENT = 'colli_withdraw_equipment',
    COLLI_GRANT_ACCESS = 'colli_grant_access',
    COLLI_DENY_ACCESS = 'colli_deny_access',
    COLLI_DROP_OFF_PACKAGES = 'colli_drop_off_packages',
    COLLI_PICK_UP_PACKAGES = 'colli_pick_up_packages',
    COLLI_TRANSACTION_DROPPED_OFF = 'colli_transaction_dropped_off',
    COLLI_TRANSACTION_PICKED_UP = 'colli_transaction_picked_up',
    COLLI_INFORM_IOT_PROCESSING = 'colli_inform_iot_processing',
    COLLI_INFORM_IOT_PROCESSED = 'colli_inform_iot_processed',
    COLLI_INFORM_IOT_PROCESSED_WITH_FAILURES = 'colli_inform_iot_processed_with_failures',
    COLLI_INFORM_IOT_CANCELLED = 'colli_inform_iot_cancelled',
    COLLI_INFORM_IOT_FAILED = 'colli_inform_iot_failed',
    COLLI_INFORM_IOT_IDENTIFIED = 'colli_inform_iot_identified',
    COLLI_UPDATE_CURRENT_LOCATION = 'colli_update_current_location',
    SHOW_WIZARD = 'show_wizard',
    COLLI_MOVE_SLOT = 'colli_move_slot',
    COLLI_INFORM_IOT_SLOT_MOVED = 'colli_inform_iot_slot_moved',
    COLLI_ACKNOWLEDGE_TRANSACTION_DROPPED_OFF = 'colli_acknowledge_transaction_dropped_off',
    COLLI_ACKNOWLEDGE_TRANSACTION_PICKED_UP = 'colli_acknowledge_transaction_picked_up',
    COLLI_ACKNOWLEDGE_TRANSACTION_CURRENT_LOCATION_UPDATED = 'colli_acknowledge_transaction_current_location_updated',
    PACKAGE_VERIFY_AUTOMATIC_PICK_UP = 'package_verify_automatic_pick_up'
}

export class ColliAction {
    static readonly COLLI_CHANGE_STATE = new ColliAction(
        ColliActionName.COLLI_CHANGE_STATE,
        (
            <FormattedMessage
                id='ColliAction.change_state'
                description='The displayed value for the ColliAction change_state'
                defaultMessage='Change state'
            />
        )
    );
    static readonly COLLI_PROCESS_PACKAGES = new ColliAction(
        ColliActionName.COLLI_PROCESS_PACKAGES,
        (
            <FormattedMessage
                id='ColliAction.process_packages'
                description='The displayed value for the ColliAction process_packages'
                defaultMessage='Process packages'
            />
        )
    );
    static readonly COLLI_CANCEL_PACKAGES = new ColliAction(
        ColliActionName.COLLI_CANCEL_PACKAGES,
        (
            <FormattedMessage
                id='ColliAction.cancel_packages'
                description='The displayed value for the ColliAction cancel_packages'
                defaultMessage='Cancel packages'
            />
        )
    );
    static readonly COLLI_ACKNOWLEDGE_PROCESSING = new ColliAction(
        ColliActionName.COLLI_ACKNOWLEDGE_PROCESSING,
        (
            <FormattedMessage
                id='ColliAction.acknowledge_processing'
                description='The displayed value for the ColliAction acknowledge_processing'
                defaultMessage='Acknowledge processing'
            />
        )
    );
    static readonly COLLI_ACKNOWLEDGE_PROCESSED = new ColliAction(
        ColliActionName.COLLI_ACKNOWLEDGE_PROCESSED,
        (
            <FormattedMessage
                id='ColliAction.acknowledge_processed'
                description='The displayed value for the ColliAction acknowledge_processed'
                defaultMessage='Acknowledge processed'
            />
        )
    );
    static readonly COLLI_ACKNOWLEDGE_PROCESSED_WITH_FAILURES = new ColliAction(
        ColliActionName.COLLI_ACKNOWLEDGE_PROCESSED_WITH_FAILURES,
        (
            <FormattedMessage
                id='ColliAction.acknowledge_processed_with_failures'
                description='The displayed value for the ColliAction acknowledge_processed_with_failures'
                defaultMessage='Acknowledge processed with failures'
            />
        )
    );
    static readonly COLLI_ACKNOWLEDGE_CANCELLED = new ColliAction(
        ColliActionName.COLLI_ACKNOWLEDGE_CANCELLED,
        (
            <FormattedMessage
                id='ColliAction.acknowledge_cancelled'
                description='The displayed value for the ColliAction acknowledge_cancelled'
                defaultMessage='Acknowledge cancelled'
            />
        )
    );
    static readonly COLLI_ACKNOWLEDGE_FAILED = new ColliAction(
        ColliActionName.COLLI_ACKNOWLEDGE_FAILED,
        (
            <FormattedMessage
                id='ColliAction.acknowledge_failed'
                description='The displayed value for the ColliAction acknowledge_failed'
                defaultMessage='Acknowledge failed'
            />
        )
    );
    static readonly COLLI_NOTIFY_SENDER = new ColliAction(
        ColliActionName.COLLI_NOTIFY_SENDER,
        (
            <FormattedMessage
                id='ColliAction.notify_sender'
                description='The displayed value for the ColliAction notify_sender'
                defaultMessage='Notify sender'
            />
        )
    );
    static readonly COLLI_NOTIFY_RECEIVER = new ColliAction(
        ColliActionName.COLLI_NOTIFY_RECEIVER,
        (
            <FormattedMessage
                id='ColliAction.notify_receiver'
                description='The displayed value for the ColliAction notify_receiver'
                defaultMessage='Notify receiver'
            />
        )
    );
    static readonly COLLI_NOTIFY_BACKUP_RECEIVER = new ColliAction(
        ColliActionName.COLLI_NOTIFY_BACKUP_RECEIVER,
        (
            <FormattedMessage
                id='ColliAction.notify_backup_receiver'
                description='The displayed value for the ColliAction notify_backup_receiver'
                defaultMessage='Notify backup receiver'
            />
        )
    );
    static readonly COLLI_CREATE_PIN_CODE = new ColliAction(
        ColliActionName.COLLI_CREATE_PIN_CODE,
        (
            <FormattedMessage
                id='ColliAction.create_pin_code'
                description='The displayed value for the ColliAction create_pin_code'
                defaultMessage='Create PIN-code'
            />
        )
    );
    static readonly COLLI_SET_PIN_CODE = new ColliAction(
        ColliActionName.COLLI_SET_PIN_CODE,
        (
            <FormattedMessage
                id='ColliAction.set_pin_code'
                description='The displayed value for the ColliAction set_pin_code'
                defaultMessage='Set PIN-code'
            />
        )
    );
    static readonly COLLI_RETIRE_PIN_CODE = new ColliAction(
        ColliActionName.COLLI_RETIRE_PIN_CODE,
        (
            <FormattedMessage
                id='ColliAction.retire_pin_code'
                description='The displayed value for the ColliAction retire_pin_code'
                defaultMessage='Retire PIN-code'
            />
        )
    );
    static readonly COLLI_RETURN_EQUIPMENT = new ColliAction(
        ColliActionName.COLLI_RETURN_EQUIPMENT,
        (
            <FormattedMessage
                id='ColliAction.return_equipment'
                description='The displayed value for the ColliAction return_equipment'
                defaultMessage='Return equipment'
            />
        )
    );
    static readonly COLLI_TRANSFER_EQUIPMENT = new ColliAction(
        ColliActionName.COLLI_TRANSFER_EQUIPMENT,
        (
            <FormattedMessage
                id='ColliAction.transfer_equipment'
                description='The displayed value for the ColliAction transfer_equipment'
                defaultMessage='Transfer equipment'
            />
        )
    );
    static readonly COLLI_WITHDRAW_EQUIPMENT = new ColliAction(
        ColliActionName.COLLI_WITHDRAW_EQUIPMENT,
        (
            <FormattedMessage
                id='ColliAction.withdraw_equipment'
                description='The displayed value for the ColliAction withdraw_equipment'
                defaultMessage='Withdraw equipment'
            />
        )
    );
    static readonly COLLI_GRANT_ACCESS = new ColliAction(
        ColliActionName.COLLI_GRANT_ACCESS,
        (
            <FormattedMessage
                id='ColliAction.grant_access'
                description='The displayed value for the ColliAction grant_access'
                defaultMessage='Grant access'
            />
        )
    );
    static readonly COLLI_DENY_ACCESS = new ColliAction(
        ColliActionName.COLLI_DENY_ACCESS,
        (
            <FormattedMessage
                id='ColliAction.deny_access'
                description='The displayed value for the ColliAction deny_access'
                defaultMessage='Deny access'
            />
        )
    );
    static readonly COLLI_DROP_OFF_PACKAGES = new ColliAction(
        ColliActionName.COLLI_DROP_OFF_PACKAGES,
        (
            <FormattedMessage
                id='ColliAction.drop_off_packages'
                description='The displayed value for the ColliAction drop_off_packages'
                defaultMessage='Drop off packages'
            />
        )
    );
    static readonly COLLI_PICK_UP_PACKAGES = new ColliAction(
        ColliActionName.COLLI_PICK_UP_PACKAGES,
        (
            <FormattedMessage
                id='ColliAction.pick_up_packages'
                description='The displayed value for the ColliAction pick_up_packages'
                defaultMessage='Pick up packages'
            />
        )
    );
    static readonly COLLI_TRANSACTION_DROPPED_OFF = new ColliAction(
        ColliActionName.COLLI_TRANSACTION_DROPPED_OFF,
        (
            <FormattedMessage
                id='ColliAction.transaction_dropped_off'
                description='The displayed value for the ColliAction transaction_dropped_off'
                defaultMessage='Transaction dropped off'
            />
        )
    );
    static readonly COLLI_TRANSACTION_PICKED_UP = new ColliAction(
        ColliActionName.COLLI_TRANSACTION_PICKED_UP,
        (
            <FormattedMessage
                id='ColliAction.transaction_picked_up'
                description='The displayed value for the ColliAction transaction_picked_up'
                defaultMessage='Transaction picked up'
            />
        )
    );
    static readonly COLLI_INFORM_IOT_PROCESSING = new ColliAction(
        ColliActionName.COLLI_INFORM_IOT_PROCESSING,
        (
            <FormattedMessage
                id='ColliAction.inform_iot_processing'
                description='The displayed value for the ColliAction inform_iot_processing'
                defaultMessage='Inform IoT processing'
            />
        )
    );
    static readonly COLLI_INFORM_IOT_PROCESSED = new ColliAction(
        ColliActionName.COLLI_INFORM_IOT_PROCESSED,
        (
            <FormattedMessage
                id='ColliAction.inform_iot_processed'
                description='The displayed value for the ColliAction inform_iot_processed'
                defaultMessage='Inform IoT processed'
            />
        )
    );
    static readonly COLLI_INFORM_IOT_PROCESSED_WITH_FAILURES = new ColliAction(
        ColliActionName.COLLI_INFORM_IOT_PROCESSED_WITH_FAILURES,
        (
            <FormattedMessage
                id='ColliAction.inform_iot_processed_with_failures'
                description='The displayed value for the ColliAction inform_iot_processed_with_failures'
                defaultMessage='Inform IoT processed with failures'
            />
        )
    );
    static readonly COLLI_INFORM_IOT_CANCELLED = new ColliAction(
        ColliActionName.COLLI_INFORM_IOT_CANCELLED,
        (
            <FormattedMessage
                id='ColliAction.inform_iot_cancelled'
                description='The displayed value for the ColliAction inform_iot_cancelled'
                defaultMessage='Inform IoT cancelled'
            />
        )
    );
    static readonly COLLI_INFORM_IOT_FAILED = new ColliAction(
        ColliActionName.COLLI_INFORM_IOT_FAILED,
        (
            <FormattedMessage
                id='ColliAction.inform_iot_failed'
                description='The displayed value for the ColliAction inform_iot_failed'
                defaultMessage='Inform IoT failed'
            />
        )
    );
    static readonly COLLI_INFORM_IOT_IDENTIFIED = new ColliAction(
        ColliActionName.COLLI_INFORM_IOT_IDENTIFIED,
        (
            <FormattedMessage
                id='ColliAction.inform_iot_identified'
                description='The displayed value for the ColliAction inform_iot_identified'
                defaultMessage='Inform IoT identified'
            />
        )
    );
    static readonly COLLI_UPDATE_CURRENT_LOCATION = new ColliAction(
        ColliActionName.COLLI_UPDATE_CURRENT_LOCATION,
        (
            <FormattedMessage
                id='ColliAction.update_current_location'
                description='The displayed value for the ColliAction update_current_location'
                defaultMessage='Update current location'
            />
        )
    );
    static readonly SHOW_WIZARD = new ColliAction(
        ColliActionName.SHOW_WIZARD,
        (
            <FormattedMessage
                id='ColliAction.show_wizard'
                description='The displayed value for the ColliAction show_wizard'
                defaultMessage='Show wizard'
            />
        )
    );
    static readonly COLLI_MOVE_SLOT = new ColliAction(
        ColliActionName.COLLI_MOVE_SLOT,
        (
            <FormattedMessage
                id='ColliAction.move_slot'
                description='The displayed value for the ColliAction move_slot'
                defaultMessage='Move SLOT'
            />
        )
    );
    static readonly COLLI_INFORM_IOT_SLOT_MOVED = new ColliAction(
        ColliActionName.COLLI_INFORM_IOT_SLOT_MOVED,
        (
            <FormattedMessage
                id='ColliAction.inform_iot_slot_moved'
                description='The displayed value for the ColliAction inform_iot_slot_moved'
                defaultMessage='Inform IoT SLOT moved'
            />
        )
    );
    static readonly COLLI_ACKNOWLEDGE_TRANSACTION_DROPPED_OFF = new ColliAction(
        ColliActionName.COLLI_ACKNOWLEDGE_TRANSACTION_DROPPED_OFF,
        (
            <FormattedMessage
                id='ColliAction.acknowledge_transaction_dropped_off'
                description='The displayed value for the ColliAction acknowledge_transaction_dropped_off'
                defaultMessage='Acknowledge transaction dropped off'
            />
        )
    );
    static readonly COLLI_ACKNOWLEDGE_TRANSACTION_PICKED_UP = new ColliAction(
        ColliActionName.COLLI_ACKNOWLEDGE_TRANSACTION_PICKED_UP,
        (
            <FormattedMessage
                id='ColliAction.acknowledge_transaction_picked_up'
                description='The displayed value for the ColliAction acknowledge_transaction_picked_up'
                defaultMessage='Acknowledge transaction picked up'
            />
        )
    );
    static readonly COLLI_ACKNOWLEDGE_TRANSACTION_CURRENT_LOCATION_UPDATED = new ColliAction(
        ColliActionName.COLLI_ACKNOWLEDGE_TRANSACTION_CURRENT_LOCATION_UPDATED,
        (
            <FormattedMessage
                id='ColliAction.acknowledge_transaction_current_location_updated'
                description='The displayed value for the ColliAction acknowledge_transaction_current_location_updated'
                defaultMessage='Acknowledge transaction current location updated'
            />
        )
    );
    static readonly PACKAGE_VERIFY_AUTOMATIC_PICK_UP = new ColliAction(
        ColliActionName.PACKAGE_VERIFY_AUTOMATIC_PICK_UP,
        (
            <FormattedMessage
                id='ColliAction.package_verify_automatic_pick_up'
                description='The displayed value for the ColliAction package_verify_automatic_pick_up'
                defaultMessage='Verify automatic pick up'
            />
        )
    );

    static readonly ALL = [
        ColliAction.COLLI_CHANGE_STATE,
        ColliAction.COLLI_PROCESS_PACKAGES,
        ColliAction.COLLI_CANCEL_PACKAGES,
        ColliAction.COLLI_ACKNOWLEDGE_PROCESSING,
        ColliAction.COLLI_ACKNOWLEDGE_PROCESSED,
        ColliAction.COLLI_ACKNOWLEDGE_PROCESSED_WITH_FAILURES,
        ColliAction.COLLI_ACKNOWLEDGE_CANCELLED,
        ColliAction.COLLI_ACKNOWLEDGE_FAILED,
        ColliAction.COLLI_NOTIFY_SENDER,
        ColliAction.COLLI_NOTIFY_RECEIVER,
        ColliAction.COLLI_NOTIFY_BACKUP_RECEIVER,
        ColliAction.COLLI_CREATE_PIN_CODE,
        ColliAction.COLLI_SET_PIN_CODE,
        ColliAction.COLLI_RETIRE_PIN_CODE,
        ColliAction.COLLI_RETURN_EQUIPMENT,
        ColliAction.COLLI_TRANSFER_EQUIPMENT,
        ColliAction.COLLI_WITHDRAW_EQUIPMENT,
        ColliAction.COLLI_GRANT_ACCESS,
        ColliAction.COLLI_DENY_ACCESS,
        ColliAction.COLLI_DROP_OFF_PACKAGES,
        ColliAction.COLLI_PICK_UP_PACKAGES,
        ColliAction.COLLI_TRANSACTION_DROPPED_OFF,
        ColliAction.COLLI_TRANSACTION_PICKED_UP,
        ColliAction.COLLI_INFORM_IOT_PROCESSING,
        ColliAction.COLLI_INFORM_IOT_PROCESSED,
        ColliAction.COLLI_INFORM_IOT_PROCESSED_WITH_FAILURES,
        ColliAction.COLLI_INFORM_IOT_CANCELLED,
        ColliAction.COLLI_INFORM_IOT_FAILED,
        ColliAction.COLLI_INFORM_IOT_IDENTIFIED,
        ColliAction.COLLI_UPDATE_CURRENT_LOCATION,
        ColliAction.SHOW_WIZARD,
        ColliAction.COLLI_MOVE_SLOT,
        ColliAction.COLLI_INFORM_IOT_SLOT_MOVED,
        ColliAction.COLLI_ACKNOWLEDGE_TRANSACTION_DROPPED_OFF,
        ColliAction.COLLI_ACKNOWLEDGE_TRANSACTION_PICKED_UP,
        ColliAction.COLLI_ACKNOWLEDGE_TRANSACTION_CURRENT_LOCATION_UPDATED,
        ColliAction.PACKAGE_VERIFY_AUTOMATIC_PICK_UP
    ];

    private constructor(
        public readonly value: ColliActionName,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(value: ColliActionName): ColliAction | undefined {
        return ColliAction.ALL.find((action) => action.value === value);
    }
}
